import { toastController } from '@ionic/vue';

const SNACK_BAR_DURATION = 2000;

type SnackBarOptions = {
  text: string;
  icon?: string;
  position?: 'top' | 'middle' | 'bottom';
  duration?: number;
};

export function useSnackBar() {
  async function show(options: SnackBarOptions) {
    const toast = await toastController.create({
      message: options.text,
      icon: options.icon,
      position: options.position ?? 'top',
      duration: options.duration ?? SNACK_BAR_DURATION,
      cssClass: 'snack-bar text-center',
    });

    await toast.present();
    return toast;
  }

  return { show };
}
